import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useBFSM } from '../../contexts/bfsmContext'

export const useHeader = (): { languages: any; numberOfReviews: number } => {
    const [BFSM] = useBFSM()
    const { i18n } = useTranslation()

    const [numberOfReviews, setNumberOfReviews] = useState<number>(0)
    const [languages, setLanguages] = useState({
        'da-DK': { nativeName: 'Dansk' },
    })

    useEffect(() => {
        const getData = async () => {
            const reviews = await BFSM.repo.getNumberOfServiceReviews()
            setNumberOfReviews(reviews)
        }
        getData()
    }, [])

    useEffect(() => {
        i18n.services.backendConnector.backend.getLanguages(
            (err: any, ret: any) => {
                if (err) return console.log('Error')
                setLanguages(ret)
            }
        )
    }, [])

    return { languages, numberOfReviews }
}
